<template>
  <div class="input-group">
    <dropdown
      class="input-group-btn left-floated-item"
      :options="options"
      :value="actualValue.option"
      :defaultValue="options[0].value"
      @selected="onDropdownChange"
    />
    <input 
      class="form-control right-floated-item"
      :value="actualValue.text"
      @input="onInputChange"
    />
  </div>
</template>
<script>
import Dropdown from '@/components/Dropdown';
import AsyncInputMixin from '@/mixins/AsyncInput';

export default {
  name: 'VariantInput',
  mixins: [AsyncInputMixin('onSyncInputChange')],
  components: { Dropdown },
  props: {
    options: Array,
    async: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
    },
  },
  methods: {
    onDropdownChange(option) {
      this.$emit('input', { option });
    },
    onSyncInputChange({ target: { value: text } }) {
      this.$emit('input', { ...this.actualValue, text });
    },
    onInputChange(event) {
      return this[this.async ? 'onAsyncInputChange' : 'onSyncInputChange'](event);
    },
  },
};
</script>
<style>
.left-floated-item .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-top: 8px;
  padding-bottom: 8px;
}
.right-floated-item {
  border-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/VariantInput.vue